"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AppRuleSetSchema = exports.AppRuleSchema = exports.APP_RULE_MESSAGE_MAX = exports.APP_RULE_TRANSITIONS_MAX = exports.APP_RULE_GROUP_BY_MAX = exports.APP_RULE_UNIQUE_COLUMNS_MAX = exports.APP_RULES_MAX = exports.evaluateAppRules = exports.AppRuleViolatedError = exports.appRuleSourceKeys = exports.appRuleRowChange = exports.appRuleColumnIds = exports.APP_RULES_LINKED_MAX = void 0;
exports.mapAppRuleColumns = mapAppRuleColumns;
exports.appRuleColumnIssues = appRuleColumnIssues;
const zod_1 = require("zod");
const app_base_source_query_schema_1 = require("./app-base-source-query-schema");
var app_rules_evaluate_1 = require("./app-rules-evaluate");
Object.defineProperty(exports, "APP_RULES_LINKED_MAX", { enumerable: true, get: function () { return app_rules_evaluate_1.APP_RULES_LINKED_MAX; } });
Object.defineProperty(exports, "appRuleColumnIds", { enumerable: true, get: function () { return app_rules_evaluate_1.appRuleColumnIds; } });
Object.defineProperty(exports, "appRuleRowChange", { enumerable: true, get: function () { return app_rules_evaluate_1.appRuleRowChange; } });
Object.defineProperty(exports, "appRuleSourceKeys", { enumerable: true, get: function () { return app_rules_evaluate_1.appRuleSourceKeys; } });
Object.defineProperty(exports, "AppRuleViolatedError", { enumerable: true, get: function () { return app_rules_evaluate_1.AppRuleViolatedError; } });
Object.defineProperty(exports, "evaluateAppRules", { enumerable: true, get: function () { return app_rules_evaluate_1.evaluateAppRules; } });
/** The most rules one App declares. */
exports.APP_RULES_MAX = 256;
/** The most columns one `unique` rule combines. */
exports.APP_RULE_UNIQUE_COLUMNS_MAX = 4;
/** The most columns a group of `groupCount` or `groupSum` is told by. */
exports.APP_RULE_GROUP_BY_MAX = 3;
/** The most allowed changes one `transition` rule names. */
exports.APP_RULE_TRANSITIONS_MAX = 64;
const sourceKey = zod_1.z.string().min(1).max(256);
const columnId = zod_1.z.string().min(1).max(128);
/** The longest own words of a rule, in each language. */
exports.APP_RULE_MESSAGE_MAX = 500;
const words = zod_1.z.string().min(1).max(exports.APP_RULE_MESSAGE_MAX);
/** The own words of a rule and the rows it holds for. */
const ruleOptions = {
    message: zod_1.z.object({ de: words, en: words }).strict().optional(),
    when: app_base_source_query_schema_1.DatabaseViewFilterGroupSchema.optional(),
};
const ruleTarget = { sourceKey, columnId, ...ruleOptions };
const groupBy = zod_1.z.array(columnId).max(exports.APP_RULE_GROUP_BY_MAX);
exports.AppRuleSchema = zod_1.z.discriminatedUnion('kind', [
    zod_1.z.object({ kind: zod_1.z.literal('required'), ...ruleTarget }).strict(),
    zod_1.z
        .object({
        kind: zod_1.z.literal('range'),
        ...ruleTarget,
        min: zod_1.z.number().finite().optional(),
        max: zod_1.z.number().finite().optional(),
    })
        .strict()
        .refine(rule => (rule.min !== undefined || rule.max !== undefined) &&
        (rule.min === undefined ||
            rule.max === undefined ||
            rule.min <= rule.max), { message: 'a range names min, max or both, min not above max' }),
    zod_1.z
        .object({
        kind: zod_1.z.literal('pattern'),
        ...ruleTarget,
        pattern: zod_1.z
            .string()
            .min(1)
            .max(512)
            .refine(isAppRulePattern, { message: 'not a regular expression' }),
    })
        .strict(),
    zod_1.z
        .object({
        kind: zod_1.z.literal('oneOf'),
        ...ruleTarget,
        values: zod_1.z.array(zod_1.z.string().min(1).max(256)).min(1).max(256),
    })
        .strict(),
    zod_1.z
        .object({
        kind: zod_1.z.literal('unique'),
        sourceKey,
        ...ruleOptions,
        columnIds: zod_1.z.array(columnId).min(1).max(exports.APP_RULE_UNIQUE_COLUMNS_MAX),
    })
        .strict(),
    zod_1.z
        .object({
        kind: zod_1.z.literal('groupCount'),
        sourceKey,
        message: ruleOptions.message,
        groupBy,
        max: zod_1.z.number().int().nonnegative().safe(),
        where: app_base_source_query_schema_1.DatabaseViewFilterGroupSchema.optional(),
    })
        .strict(),
    zod_1.z
        .object({
        kind: zod_1.z.literal('groupSum'),
        sourceKey,
        message: ruleOptions.message,
        groupBy,
        columnId,
        max: zod_1.z.number().finite(),
        where: app_base_source_query_schema_1.DatabaseViewFilterGroupSchema.optional(),
    })
        .strict(),
    zod_1.z
        .object({
        kind: zod_1.z.literal('transition'),
        ...ruleTarget,
        allowed: zod_1.z
            .array(zod_1.z
            .object({
            from: zod_1.z.string().max(256),
            to: zod_1.z.array(zod_1.z.string().max(256)).min(1).max(256),
        })
            .strict())
            .min(1)
            .max(exports.APP_RULE_TRANSITIONS_MAX),
    })
        .strict(),
    zod_1.z
        .object({
        kind: zod_1.z.literal('linked'),
        ...ruleTarget,
        targetSourceKey: sourceKey,
        quantifier: zod_1.z.enum(['all', 'some', 'none']),
        filter: app_base_source_query_schema_1.DatabaseViewFilterGroupSchema,
    })
        .strict(),
]);
exports.AppRuleSetSchema = zod_1.z
    .object({
    version: zod_1.z.literal(1),
    rules: zod_1.z.array(exports.AppRuleSchema).max(exports.APP_RULES_MAX),
})
    .strict();
/**
 * The rule set with each column id as `columnIdOf` names it for its source:
 * a host whose tables hold the App's columns under other ids (a column map)
 * checks the rules in the ids of its tables.
 */
function mapAppRuleColumns(ruleSet, columnIdOf) {
    const mapFilter = (sourceKey, filter) => ({
        ...filter,
        conditions: filter.conditions.map(node => node.type === 'group'
            ? mapFilter(sourceKey, node)
            : {
                ...node,
                left: { ...node.left, name: columnIdOf(sourceKey, node.left.name) },
            }),
    });
    return {
        version: ruleSet.version,
        rules: ruleSet.rules.map((rule) => {
            const at = (columnId) => columnIdOf(rule.sourceKey, columnId);
            switch (rule.kind) {
                case 'unique':
                    return {
                        ...rule,
                        columnIds: rule.columnIds.map(at),
                        ...(rule.when
                            ? { when: mapFilter(rule.sourceKey, rule.when) }
                            : {}),
                    };
                case 'groupCount':
                    return {
                        ...rule,
                        groupBy: rule.groupBy.map(at),
                        ...(rule.where
                            ? { where: mapFilter(rule.sourceKey, rule.where) }
                            : {}),
                    };
                case 'groupSum':
                    return {
                        ...rule,
                        groupBy: rule.groupBy.map(at),
                        columnId: at(rule.columnId),
                        ...(rule.where
                            ? { where: mapFilter(rule.sourceKey, rule.where) }
                            : {}),
                    };
                case 'linked':
                    return {
                        ...rule,
                        columnId: at(rule.columnId),
                        filter: mapFilter(rule.targetSourceKey, rule.filter),
                        ...(rule.when
                            ? { when: mapFilter(rule.sourceKey, rule.when) }
                            : {}),
                    };
                default:
                    return {
                        ...rule,
                        columnId: at(rule.columnId),
                        ...(rule.when
                            ? { when: mapFilter(rule.sourceKey, rule.when) }
                            : {}),
                    };
            }
        }),
    };
}
/** Column types holding several values or links: no key of a row or group. */
const LIST_COLUMN_TYPES = new Set(['multi-select', 'relation', 'attachment']);
/**
 * The issues of `rules` against the columns of their sources: each column a
 * rule names exists, a sum adds a number column, a linked rule follows a
 * relation to its target source, keys of rows and groups hold one value, and
 * filters name columns of the source they filter. Where an App definition
 * meets its table schemas (WorkspaceAppSourceSchema), like
 * appBaseAttachmentDownloadIssues.
 */
function appRuleColumnIssues(rules, columnsBySource) {
    const issues = [];
    rules.rules.forEach((rule, index) => {
        const at = (...path) => ['rules', index, ...path];
        const column = (key, id) => columnsBySource[key]?.find(item => item.id === id);
        const requireColumn = (key, id, path, fits = () => true, what = 'a column') => {
            const found = column(key, id);
            if (!found || !fits(found))
                issues.push({
                    message: `App rule ${rule.kind} needs ${what} ${key}.${id}`,
                    path,
                });
        };
        const singleValue = (found) => !LIST_COLUMN_TYPES.has(found.type);
        const filterColumns = (key, filter, path) => {
            const visit = (node, nodePath) => {
                if (node.type === 'group') {
                    node.conditions.forEach((child, childIndex) => visit(child, [...nodePath, 'conditions', childIndex]));
                    return;
                }
                requireColumn(key, node.left.name, [...nodePath, 'left', 'name']);
            };
            if (filter)
                visit(filter, path);
        };
        switch (rule.kind) {
            case 'unique':
                rule.columnIds.forEach((id, i) => requireColumn(rule.sourceKey, id, at('columnIds', i), singleValue, 'a single-value column'));
                filterColumns(rule.sourceKey, rule.when, at('when'));
                return;
            case 'groupCount':
            case 'groupSum':
                rule.groupBy.forEach((id, i) => requireColumn(rule.sourceKey, id, at('groupBy', i), singleValue, 'a single-value column'));
                if (rule.kind === 'groupSum')
                    requireColumn(rule.sourceKey, rule.columnId, at('columnId'), found => found.type === 'number', 'a number column');
                filterColumns(rule.sourceKey, rule.where, at('where'));
                return;
            case 'linked':
                requireColumn(rule.sourceKey, rule.columnId, at('columnId'), found => found.type === 'relation' &&
                    found.relation?.targetSourceKey === rule.targetSourceKey, `a relation column to ${rule.targetSourceKey} as`);
                filterColumns(rule.targetSourceKey, rule.filter, at('filter'));
                filterColumns(rule.sourceKey, rule.when, at('when'));
                return;
            default:
                requireColumn(rule.sourceKey, rule.columnId, at('columnId'));
                filterColumns(rule.sourceKey, rule.when, at('when'));
        }
    });
    return issues;
}
/** Whether a text is a pattern a rule may hold (Unicode regular expression). */
function isAppRulePattern(pattern) {
    try {
        new RegExp(pattern, 'u');
        return true;
    }
    catch {
        return false;
    }
}
